import { Layout } from 'plotly.js'

export const joinClassNames = (
    ...classNames: (string | boolean | null | undefined)[]
) => {
    return classNames.reduce<string>((total, className, index) => {
        if (className && typeof className !== 'boolean') {
            return index === 0 ? className : total + ' ' + className
        }

        return total
    }, '')
}

interface IColor {
    background: string
    font: string
}

export const getPlotlyColorScale = (type: string) => {
    const colors = getPlotlyColors(type)

    return colors.reduce(
        (
            acc: Array<[number, string]>,
            color: string,
            index,
            arr
        ): Array<[number, string]> => {
            acc.push([index / (arr.length - 1), color])

            return acc
        },
        []
    )
}

export const getPlotlyColors = (type: string) => {
    switch (type) {
        case 'bar':
            return ['#93C4D2', '#5A9BAD', '#477D8B']
        case 'scatter':
            return ['#05A7D6', '#F5937A']
        case 'pie':
            return [
                '#8EE2FA',
                '#3CC4EB',
                '#05A7D6',
                '#7DAD82',
                '#9FD7A5',
                '#CBFCD0',
                '#F5937A',
                '#FAAF9C',
                '#FDDED7',
                '#5A9BAD',
                '#477D8B',
            ]
        case 'heatmap':
            return [
                '#FFFFFF',
                '#CDF3FE',
                '#8EE2FA',
                '#3CC4EB',
                '#67D1EF',
                '#05A7D6',
            ]
        default:
            return ['#93C4D2', '#5A9BAD', '#477D8B']
    }
}

export const getPlotlyLayout = (type: string): Partial<Layout> => {
    return {
        colorway: getPlotlyColors(type),
        font: { size: 14 },
        height: 500,
        hoverlabel: {
            bgcolor: '#1483ea',
            bordercolor: 'transparent',
            font: {
                color: 'white',
            },
        },
        xaxis: {
            showgrid: false,
            automargin: true,
            autorange: true,
        },
        yaxis: {
            showgrid: false,
            showline: true,
            automargin: true,
            autorange: true,
            ticklen: 8,
            showdividers: true,
        },
        showlegend: true,
        legend: { orientation: type !== 'bar' ? 'h' : 'v' },
    }
}

export const colors: IColor[] = [
    {
        background: '#E3FFF2',
        font: '#0B5030',
    },
    {
        background: '#FFF9D9',
        font: '#645400',
    },
    {
        background: '#F9F1FF',
        font: '#561688',
    },
    {
        background: '#F1F6FF',
        font: '#205ECE',
    },
]

export const getInitials = (string: string) => {
    return string.slice(0, 2).toUpperCase()
}

export const stringToColor = (string: string) =>
    colors[string.length % colors.length]
